
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seguro",
      function () {
        return require("private-next-pages/seguro/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seguro"])
      });
    }
  